import { ErgebnisInvBedKeKomplett } from '../ws/ergebnis/gebaeude/invBedKe/ergebnis-inv-bed-ke-komplett.model';
import { Ergebnisse } from '../ws/ergebnis/ergebnisse.model';

export class TableInvBedKe {
  kge!: string;
  bezeichnung!: string;
  gesamtPreis: number[] = [];
  isUeberschrift: boolean = false;
  isSumme: boolean = false;

  public static getTableInvBedKeList(ergebnisse: Ergebnisse): TableInvBedKe[] {
   
    if (ergebnisse.ergebnisGebaeudeList.length == 0) return [];
   
    let tableInvBedKe: TableInvBedKe[] = [];
    let kgeList: string[] = [];
    let ergebnisInvBedKeKomplett: ErgebnisInvBedKeKomplett =
      ergebnisse.ergebnisGebaeudeList[0].ergebnisInvBedKeKomplett;

    ergebnisInvBedKeKomplett.ergebnisInvBedKeList.forEach((entry, i) => {
      let korrektur: number[] = new Array(ergebnisse.ergebnisGebaeudeList.length).fill(0);
      let element: TableInvBedKe = new TableInvBedKe();

      element.bezeichnung = entry.bezeichnung;
      element.kge = entry.ke;
      element.isUeberschrift = true;

      tableInvBedKe.push(element); 
      entry.ergebnisInvBedKeList.forEach((entry2, j) => {
       

        kgeList.push(entry2.kge);

        let element2: TableInvBedKe = new TableInvBedKe();
        element2.bezeichnung = entry2.bezeichnung;
        element2.kge = entry2.kge;
        
        ergebnisse.ergebnisGebaeudeList.forEach((entry3, k) => {
  
          if (

           entry3.ergebnisInvBedKeKomplett.ergebnisInvBedKeList[i] != undefined && entry3.ergebnisInvBedKeKomplett.ergebnisInvBedKeList[i]
              .ergebnisInvBedKeList[j-korrektur[k] ] != undefined
          ) {
            if (
              entry3.ergebnisInvBedKeKomplett.ergebnisInvBedKeList[i]
                .ergebnisInvBedKeList[j-korrektur[k]].kge != element2.kge
            ) {
              
              korrektur[k]+=1;
              element2.gesamtPreis.push(-1);


            } else {
              element2.gesamtPreis.push(
                entry3.ergebnisInvBedKeKomplett.ergebnisInvBedKeList[i]
                  .ergebnisInvBedKeList[j-korrektur[k] ].gesamtpreisSum
              );
            }
          } else {
         

            element2.gesamtPreis.push(-1);
          }
        });

        tableInvBedKe.push(element2);
      });
    });

    let element: TableInvBedKe = new TableInvBedKe();
    element.kge = ergebnisInvBedKeKomplett.ergebnisInvBedKeGesamt.kge;

    ergebnisse.ergebnisGebaeudeList.forEach((entry) => {
      element.gesamtPreis.push(
        entry.ergebnisInvBedKeKomplett.ergebnisInvBedKeGesamt.gesamtpreisSum
      );
      element.isUeberschrift = true;
      element.isSumme = true;
    });

    tableInvBedKe.push(element);

    tableInvBedKe.forEach((entry) => {
      if (entry.gesamtPreis.length > 1) {
        entry.gesamtPreis = entry.gesamtPreis.slice(1); 
      }
    });

    return tableInvBedKe;
  }
}
